import { BasicService } from "./core/basic.service";
import { Http } from "./core/http";

export class OrderService extends BasicService {

  static getList(data) {
    // if (data.order_sn) {
    //   const http = new Http('https://api.goodyiyao.cn/web/');
    //   return http.post('/order/orderList', data);
    // }
    return this.http.post('/order/orderList', data);
  }

  static detail(order_id) {
    return this.http.post('/order/orderDetail', { order_id });
  }

  static refund(order_id) {
    return this.http.post('/order/userRefund', { order_id });
  }

  static refundConfirm(data) {
    return this.http.post('/order/refundConfirmation', data);
  }

  static refundCheck(order_id) {
    return this.http.post('/order/goodsRefundCheck', { order_id });
  }

  static reject(order_id, reject_reason) {
    return this.http.post('/order/orderReject', { order_id, reject_reason });
  }

  static refundRequest(order_id) {
    return this.http.post('/order/orderRefund', { order_id });
  }

  static send(order_id, shipping_sn, shipping_name) {
    return this.http.post('/order/orderSend', { order_id, shipping_sn, shipping_name });
  }

  static delete(order_id) {
    return this.http.post('/order/delOrder', { order_id });
  }

  static editAmount(order_id, discount) {
    return this.http.post('/order/editMoney', { order_id, discount });
  }

  static editAddress(data) {
    return this.http.post('/order/editOrderAddress', data);
  }

  static advanceCharge(data) {
    return this.http.post('/order/advanceCharge', data);
  }

  static logistics(order_id) {
    return this.http.post('/order/orderLogistics', { order_id });
  }

  static shippList(data) {
    return this.http.post('/shipping/getList', data);
  }

  static orderLog(data) {
    return this.http.post('/order/orderLogList', data);
  }
  static queryShipping(order_sn) {
    // const http = new Http('https://api.goodyiyao.cn/web');
    return this.http.post('/shipping/query', { order_sn });
  }
  // 更改物流信息
  static editDelivery(data){
    return this.http.post('/order/shippingSave', data);
  }
}